var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"single-choice-item"},[_c('question',{attrs:{"text":_vm.$t(_vm.item.text)}}),_c('multi-buttons',{attrs:{"options":_vm.options},on:{"select":_vm.handleSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }